import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Events from '../partials/Events';
import PageMeta from '../partials/PageMeta';
import Title from '../typography/Title';

import styles from '../../../styles/pages/events.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function EventsPage({ page: initialPage = null }) {
    const { title = null } = initialPage || {};

    return (
        <div className={styles.container}>
            <PageMeta page={initialPage} />
            <Title className={styles.title} size="large">
                {title || (
                    <FormattedMessage defaultMessage="Events" description="Events page title" />
                )}
            </Title>
            <Events className={styles.events} query={{ upcoming: true }} />
        </div>
    );
}

EventsPage.propTypes = propTypes;

export default EventsPage;
